export const REQUIRED_PIN_LENGTH = 4;
export const SMS_CODE_LENGTH = 6;